import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "App";
import "simplebar-react/dist/simplebar.min.css";

import { MaterialUIControllerProvider } from "context";
import { StoreProvider } from "easy-peasy";
import store from "store";
const root = createRoot(document.getElementById("root"));

root.render(
  <HashRouter>
    <StoreProvider store={store}>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </StoreProvider>
  </HashRouter>
);
